import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-granth-outstanding-report',
  templateUrl: './granth-outstanding-report.component.html',
  styleUrls: ['./granth-outstanding-report.component.scss']
})
export class GranthOutstandingReportComponent implements OnInit {

  startDate: any = '';
  endDate: any = '';

  repName: any = [];
  offRepName: any = [];
  booksellerName: any = [];

  reportType: any = '';

  currentDate = new Date();

  OutstandingInDetailFormBeans: any[] = [];

  OutStandingIDTotal: number = 0;
  OutStandingIDNetAmtTotal: number = 0;
  OutStandingIDUnPaidTotal: number = 0;
  OutStandingIDCrdtTotal: number = 0;

  constructor(
    private dialogRef: MatDialogRef<GranthOutstandingReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {

    console.log("Dialog Data :", this.data);

    this.startDate = this.data.startDate;
    this.endDate = this.data.endDate;

    this.reportType = this.data.reportType;

    this.repName = this.data.repName || [];
    this.offRepName = this.data.officeRepWise || [];
    this.booksellerName = this.data.bookSellerWise || [];

    this.getOutstandingReport();

  }

  getOutstandingReport() {

    const req: any = {};

    if (this.startDate) {
      req.start_date = this.startDate;
    }

    if (this.endDate) {
      req.end_date = this.endDate;
    }

    if (this.repName.length > 0) {
      req.rep_name = this.repName;
    }

    if (this.offRepName.length > 0) {
      req.office_rep_name = this.offRepName;
    }

    if (this.booksellerName.length > 0) {
      req.book_seller_name = this.booksellerName;
    }

    console.log("API REQUEST :", req);

    this.service.getBookOutstandingInDetailgranth(req)
      .subscribe((res: any) => {

        console.log("API RESPONSE :", res);

        this.OutstandingInDetailFormBeans = res;

        this.calculateTotal();

        this.cdr.detectChanges();

      });

  }

  calculateTotal() {

    this.OutStandingIDTotal = 0;
    this.OutStandingIDNetAmtTotal = 0;
    this.OutStandingIDUnPaidTotal = 0;
    this.OutStandingIDCrdtTotal = 0;

    this.OutstandingInDetailFormBeans.forEach((office: any) => {

      office.rep_data.forEach((rep: any) => {

        this.OutStandingIDTotal += Number(rep.inv_amt_total) || 0;
        this.OutStandingIDNetAmtTotal += Number(rep.net_amt_total) || 0;
        this.OutStandingIDUnPaidTotal += Number(rep.unpaid_amt_total) || 0;
        this.OutStandingIDCrdtTotal += Number(rep.crdt_amt_total) || 0;

      });

    });

  }

  printPageA4() {

    const printContent = document.getElementById('print-section');

    if (!printContent)
      return;

    const WindowPrt: any = window.open('', '', 'width=1400,height=900');

    WindowPrt.document.write(`
    <html>
    <head>
    <title>
    Book Outstanding Report
    </title>
    <style>
    @page{
      size:A4 landscape;
      margin:8mm;
    }
    body{
      font-family:Arial;
      font-size:12px;
    }
    table{
      width:100%;
      border-collapse:collapse;
    }
    th,td{
      border:1px solid black;
      padding:5px;
    }
    thead{
      display:table-header-group;
    }
    tr{
      page-break-inside:avoid;
    }
    </style>
    </head>
    <body>
    ${printContent.innerHTML}
    </body>
    </html>
    `);

    WindowPrt.document.close();

    setTimeout(() => {
      WindowPrt.print();
      WindowPrt.close();
    }, 500);

  }

  close() {
    this.dialogRef.close();
  }

}